import { Alert } from './Alert';
import { jsx as _jsx } from "react/jsx-runtime";
export const AlertDanger = props => /*#__PURE__*/_jsx(Alert, Object.assign({}, props, {
  type: "danger"
}));